export default {
  en: {
    translation: {
      bot_title: "Bot - Bulgarian Citizenship",
      check_status_for_free:
        "Check the status of Bulgarian citizenship for free. Get a notification in Telegram or by email, when the status changes.",
      monitor_status_in: "Monitor your status in the",
      directorate_corespondence:
        "Directorate Bulgarian Citizenship, Correspondence",
      via_bot_sends_message:
        "via the bot, that checks it at the Ministry of Justice website every day and sends a message in Telegram " +
        "or by email when the status changes.",
      bot_is_not_official:
        "Note, this bot is not an official application of the Directorate Bulgarian Citizenship.",
      use_bot_telegram: "Bot for Telegram",
      use_bot_email: "Bot for email",
      // commands: "Telegram commands",
      // help: "help",
      // enter_num_and_pin: "enter incoming number and pin",
      // view_status: "view your status",
      // clear_data: "clear personal data",
      // if_user_blocks_bot:
      //   "If a user blocks the bot, their personal data are removed automatically.",
      feedback: "Feedback",
      help_about_the_bot:
        "For feedback or additional information about the bot, contact ",
      help_about_the_citizenship:
        "For questions related to the citizenship applications, please contact the Directorate Bulgarian Citizenship.",
      email: "Email",
      email_placeholder: "Enter email",
      reqnum: "Incoming number",
      reqnum_placeholder: "Enter incoming number",
      pin: "Pin",
      pin_placeholder: "Enter pin",
      continue: "Continue",
      pending: "A registration approval email is sent to you.",
      success:
        "Your email has been approved. Now you will receive updates about your status in " +
        "the Directorate Bulgarian Citizenship in case the status changes.",
      home: "Main page",
      unsubscribed: "You won't receive notifications anymore.",
    },
  },
  bg: {
    translation: {
      bot_title: "Бот - Българско Гражданство",
      check_status_for_free:
        "Безплатна автоматична проверка на статуса на българско гражданство. Получи уведомление в Telegram " +
        "или по електронна поща, когато статусът се промени.",
      monitor_status_in: "Следи статуса си в",
      directorate_corespondence:
        'Дирекцията "Българско гражданство", Информация за преписка',
      via_bot_sends_message:
        "с помощта на бот, който го проверява на сайта на Министерството на правосъдието всеки ден и изпраща " +
        "съобщение в Telegram или по електронна поща, когато статусът се променя.",
      bot_is_not_official:
        'Забележете, че този бот не е официално приложение на Дирекцията "Българско гражданство".',
      use_bot_telegram: "Бот за Telegram",
      use_bot_email: "Бот за имейл",
      // commands: "Telegram команди",
      // help: "помощ",
      // enter_num_and_pin: "въвеждане на входящ номер и пин",
      // view_status: "преглед на статуса си",
      // clear_data: "изтриване на лични данни",
      // if_user_blocks_bot:
      //   "Ако потребител(ка) блокира бота, личните им данни се изтриват автоматично.",
      feedback: "Обратна връзка",
      help_about_the_bot:
        "За обратна връзка или допълнителна информация относно бота, пишете на ",
      help_about_the_citizenship:
        'За въпроси, свързани с молбите за гражданство, моля, свържете се с Дирекцията "Българско гражданство".',
      email: "Поща",
      email_placeholder: "Въведи имейл",
      reqnum: "Входящ номер",
      reqnum_placeholder: "Въведи входящ номер",
      pin: "Пин",
      pin_placeholder: "Въведи пин",
      continue: "Продължи",
      pending: "На теб е изпратено писмо с потвърждение на регистрацията.",
      success:
        "Имейлът беше потвърден. Ще получиш съобщение, когато статусът ти " +
        `в Дирекцията "Българско гражданство" се промени.`,
      home: "Към главната",
      unsubscribed: "Повече няма да получаваш уведомленията.",
    },
  },
};
